  const closeBtn = document.querySelector('.newsletter_close');
  const nonediv = document.querySelector('.newsletter-poup_layer');
  const popup = document.querySelector('.newsletter_popup');
  const boduclass = document.querySelector('body');

  if (closeBtn && popup && nonediv) {
    closeBtn.addEventListener('click', function () {
      popup.style.display = 'none';
      nonediv.style.display = 'none';
       boduclass.classList.remove('overflow-hiddenee');
      // localStorage.setItem('popupClosed', 'true');

    });
  }


const overlaydiv  = document.querySelector('.newsletter-poup_layer');
if (overlaydiv && popup && nonediv) {
    overlaydiv.addEventListener('click', function () {
      popup.style.display = 'none';
      nonediv.style.display = 'none';
        boduclass.classList.remove('overflow-hiddenee');
    });
  }
document.addEventListener('DOMContentLoaded', function () {

  // if (localStorage.getItem('popupClosed') === 'true') {
  //   return;
  // }
  
});

  if (popup) {
  
 
    const discountEls = document.querySelectorAll('[discount_popup_open]');

    // length check
    if (discountEls.length > 0) {
      discountEls.forEach(function (el) {

        el.addEventListener('click', function (e) {
          e.preventDefault(); // prevent default action

          popup.style.display = 'flex';
          boduclass.classList.add('overflow-hiddenee');
          nonediv.style.display = 'block';
        });
      });
    }
  


  }


const swiper = new Swiper(".testimonial-box-wrapper", {
  loop: false,
  speed: 1000,
  navigation: {
    nextEl: ".testimonial-custom-block .swiper-button-next",
    prevEl: ".testimonial-custom-block .swiper-button-prev",
  },
  pagination: {
    el: ".testimonial-box-wrapper .swiper-pagination",
    clickable: true,
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  effect: "slide",
  breakpoints: {
    350: {
      slidesPerView: 1,
      spaceBetween: 0,
      autoHeight: true,
    },
    750: {
      slidesPerView: 2,
      spaceBetween: 15
    },
    992: {
      slidesPerView: 3,
      spaceBetween: 15
    },
    1200: { slidesPerView: 3, spaceBetween: 15 },
  },
});




document.addEventListener('click', function (e) {
  const sub = e.target.closest('.ingredient-sub');
  if (!sub) return;

  const item = sub.closest('.ingredient-item');
  if (!item) return;

  item.classList.toggle('active');
});


document.addEventListener('click', function (e) {
  const header = e.target.closest('.pdp-faq-item > h5');
  if (!header) return;

  const item = header.closest('.pdp-faq-item');
  const wrapper = header.closest('.product-faq-wrp');

  if (!item || !wrapper) return;

  // close others
  wrapper.querySelectorAll('.pdp-faq-item.active').forEach(el => {
    if (el !== item) el.classList.remove('active');
  });

  // toggle current
  item.classList.toggle('active');
});


// ====== faq page accordian  ======
document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        if (!localStorage.getItem("firstLoad")) {
            const modal = document.querySelector(".custom-model-main");
            if (modal) {
                modal.classList.add("model-open");
                localStorage.setItem("firstLoad", "true");
            }
        }
    }, 3000);

    document.querySelectorAll(".close-btn, .bg-overlay").forEach(function (element) {
        element.addEventListener("click", function () {
            const modal = document.querySelector(".custom-model-main");
            if (modal) {
                modal.classList.remove("model-open");
            }
        });
    });

    if (document.body.clientWidth < 991) {
        const lastCollage = document.querySelector(".last_collage.image_banner_collage_item");
        const collageSecond = document.querySelector(".collage_second.image_banner_collage_item");
        if (lastCollage && collageSecond) {
            collageSecond.after(lastCollage);
        }
    }

    if (document.body.clientWidth < 750) {
        const imageMedia = document.querySelector(".about-image-text-bg.image-with-text__media-item");
        const imageText = document.querySelector(".about-image-text-bg.image-with-text__text-item");
        if (imageMedia && imageText) {
            imageText.after(imageMedia);
        }
    }

    document.querySelectorAll(".faq_accordion .accordion").forEach(function (accordion) {
        accordion.addEventListener("click", function () {
            const isOpen = accordion.classList.contains("is-open");
            document.querySelectorAll(".faq_accordion .accordion").forEach(function (item) {
                item.classList.remove("is-open");
                const content = item.nextElementSibling;
                if (content) content.style.maxHeight = "0px";
            });
            if (!isOpen) {
                accordion.classList.add("is-open");
                const content = accordion.nextElementSibling;
                if (content) content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });

    document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(function (accordion) {
        accordion.addEventListener("click", function () {
            const isOpen = accordion.classList.contains("is-open");
            document.querySelectorAll(".faq-page_main_wrapper .accordion").forEach(function (item) {
                item.classList.remove("is-open");
                const content = item.nextElementSibling;
                if (content) content.style.maxHeight = "0px";
            });
            if (!isOpen) {
                accordion.classList.add("is-open");
                const content = accordion.nextElementSibling;
                if (content) content.style.maxHeight = content.scrollHeight + "px";
            }
        });
    });
});

// -------------- faq page  js
const faqtitle = document.querySelectorAll('.template-faqs .faq-btn');

faqtitle.forEach(faqtitles => {
  faqtitles.addEventListener('click', function (event) {
    event.preventDefault();

    const gettitle = this.getAttribute('data-btn-title');
    console.log(gettitle, "gettitle");
    faqtitle.forEach(btn => btn.classList.remove('active')); // Remove from all buttons
    this.classList.add('active');


    document.querySelectorAll('.faq-page-content').forEach(content => {
      content.style.display = "none";
    });

    const contentdiv = document.querySelector(`.faq-page-content[data-faq-content="${gettitle}"]`);

    if (contentdiv) {
      contentdiv.style.display = "block";
    }
   const classremove  =  document.querySelector('.dropdown-content');
   if(classremove)
   {

     classremove.classList.remove('dropdown-active')
   }
  });
});

const readMoreBtn = document.querySelector('.collection-read-more');

if (readMoreBtn) {
  readMoreBtn.addEventListener('click', function () {
    const parent = this.closest('.collection-desc');
    if (parent) {
      parent.classList.add('collection-active');
    }
  });
}


// PDP Media Mobile Pagination Slider
const slider = document.querySelector('.product__media-list');
if(slider){

  const slides = [...slider.children];

  const prevBtn = document.querySelector('.slider-button--prev');
  const nextBtn = document.querySelector('.slider-button--next');
  const currentEl = document.querySelector('.slider-counter--current');
  const totalEl = document.querySelector('.slider-counter--total');
  const dotsContainer = document.querySelector('.slider-dots');

  totalEl.textContent = slides.length;

  // Create dots
  slides.forEach((_, i) => {
    const dot = document.createElement('button');
    dot.className = 'slider-dot';
    dot.setAttribute('aria-label', `Slide ${i + 1}`);
    dot.addEventListener('click', () => {
      slides[i].scrollIntoView({ behavior: 'smooth' });
    });
    dotsContainer.appendChild(dot);
  });

  const dots = [...dotsContainer.children];

  function updateUI(index) {
    currentEl.textContent = index + 1;

    prevBtn.disabled = index === 0;
    nextBtn.disabled = index === slides.length - 1;

    dots.forEach(d => d.classList.remove('is-active'));
    dots[index].classList.add('is-active');
  }
  
    // Scroll snap detection
    const observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const index = slides.indexOf(entry.target);
            updateUI(index);
          }
        });
      },
      { threshold: 0.6 }
    );
  
    slides.forEach(slide => observer.observe(slide));
    // Prev / Next buttons
    prevBtn.addEventListener('click', () => {
      const index = dots.findIndex(d => d.classList.contains('is-active'));
      if (index > 0) slides[index - 1].scrollIntoView({ behavior: 'smooth' });
    });
    
    nextBtn.addEventListener('click', () => {
      const index = dots.findIndex(d => d.classList.contains('is-active'));
      if (index < slides.length - 1) slides[index + 1].scrollIntoView({ behavior: 'smooth' });
    });
}

// Blog Details Page Heading Scroll Active JS
document.addEventListener("DOMContentLoaded", () => {
  const links = document.querySelectorAll(".table-contents a");
  const headings = document.querySelectorAll(".article_content_inner h2[id],.article_content_inner h1[id]");

  const getHeaderOffset = () => {
    const header = document.querySelector("header");
    return header ? header.offsetHeight : 100;
  };

  /* =========================
     CLICK SCROLL
  ========================== */
  links.forEach(link => {
    link.addEventListener("click", e => {
      e.preventDefault();

      const id = link.getAttribute("href").substring(1);
      const target = document.getElementById(id);
      if (!target) return;

      links.forEach(l => l.classList.remove("active"));
      link.classList.add("active");

      const offset = getHeaderOffset();
      const top =
        target.getBoundingClientRect().top + window.pageYOffset - offset;

      window.scrollTo({
        top: top,
        behavior: "smooth"
      });
    });
  });

  /* =========================
     SCROLL ACTIVE FIX
  ========================== */
  const onScroll = () => {
    const offset = getHeaderOffset();
    let currentId = null;

    // ✅ Fix: If at very top → first heading active
    if (window.scrollY < 100) {
      currentId = headings[0]?.id;
    } else {
      headings.forEach(heading => {
        const rect = heading.getBoundingClientRect();

        if (rect.top <= offset + 120) {
          currentId = heading.id;
        }
      });
    }

    if (currentId) {
      links.forEach(link => {
        link.classList.toggle(
          "active",
          link.getAttribute("href") === `#${currentId}`
        );
      });
    }
  };

  /* =========================
     INITIAL LOAD FIX
  ========================== */
  const setInitialActive = () => {
    const offset = getHeaderOffset();
    let currentId = null;

    headings.forEach(heading => {
      const rect = heading.getBoundingClientRect();

      if (rect.top <= offset + 120) {
        currentId = heading.id;
      }
    });

    // ✅ fallback to first heading
    if (!currentId && headings.length) {
      currentId = headings[0].id;
    }

    if (currentId) {
      links.forEach(link => {
        link.classList.toggle(
          "active",
          link.getAttribute("href") === `#${currentId}`
        );
      });
    }
  };

  /* =========================
     EVENTS
  ========================== */
  window.addEventListener("scroll", onScroll);
  window.addEventListener("load", () => {
    setInitialActive();
    onScroll(); // ensure correct state
  });
});


